import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type { ICampaignLayout } from '@/api/types';
import { campaignLayoutSection } from '@/constants/client/campainLayout';

export const initialState: ICampaignLayout = {
  showSideBarSection: true,
  showListSection: false,
  showDetailsSection: false,
};

export const campaignsLayoutSlice = createSlice({
  name: 'campaignsLayout',
  initialState,
  reducers: {
    updateMobileLayout(state) {
      state.showSideBarSection = initialState.showSideBarSection;
      state.showListSection = initialState.showListSection;
      state.showDetailsSection = initialState.showDetailsSection;
    },
    updateDesktopLayout(state) {
      state.showSideBarSection = true;
      state.showListSection = true;
      state.showDetailsSection = true;
    },
    updateLayout(state, { payload }) {
      const defaultValue = {
        showSideBarSection: false,
        showListSection: false,
        showDetailsSection: false,
      };

      if (
        payload &&
        (payload === campaignLayoutSection.showDetailsSection ||
          payload === campaignLayoutSection.showListSection ||
          payload === campaignLayoutSection.showSideBarSection)
      ) {
        const newState = { ...defaultValue, [payload]: true };
        state.showSideBarSection = newState.showSideBarSection;
        state.showListSection = newState.showListSection;
        state.showDetailsSection = newState.showDetailsSection;
      }
    },
  },
});

// actions
export const { updateLayout, updateDesktopLayout, updateMobileLayout } = campaignsLayoutSlice.actions;

// selectors
export const getCampaignLayout = (state: RootState): ICampaignLayout => state.campaignLayout;

export default campaignsLayoutSlice.reducer;
